"use client";

import { motion, useInView } from "framer-motion";
import { FC, useEffect, useRef, useState } from "react";

import { DataGrid as DataGridType } from "@/components/UnitGallery/type";
import Icon from "@/components/ui/Icon/Icon";

import "./DataGrid.css";

interface DataGridProps {
  entry: DataGridType;
  animation?: boolean;
  indexKey?: number;
}

const DataGrid: FC<DataGridProps> = ({ entry, animation, indexKey }) => {
  const componentRef = useRef<HTMLUListElement>(null);
  const isInView = useInView(componentRef);
  const [hasAnimated, setHasAnimated] = useState(false);

  const fadeVariants = {
    visible: { opacity: 1, y: 0, transition: { delay: indexKey, duration: 1, ease: "easeInOut" } },
    hidden: { opacity: 0, y: 20 },
  };

  useEffect(() => {
    if (isInView && !hasAnimated && animation) {
      setHasAnimated(true);
    }
  }, [isInView, hasAnimated, animation]);

  return (
    <motion.ul
      ref={componentRef}
      className="flex flex-wrap px-m items-start justify-between gap-y-m py-[20px] md:px-[40px] md:py-0 md:w-20\/24 mx-auto"
      initial={animation ? "hidden" : ""}
      animate={animation ? (hasAnimated ? "visible" : "hidden") : "visible"}
      variants={fadeVariants}
    >
      {entry.icons.map((item, i) => (
        <li className={`flex flex-1 basis-1/3 md:basis-1/3 justify-center pt-l`} key={`${item.id}-${i}`}>
          <div className="flex flex-col items-center  w-[200px] ">
            {item.icon && <Icon className="stroke-gold" name={item.icon as string} size="56" />}

            {/* {item.icon?.link?.icon && <Icon className="stroke-gold" name={item.icon.link.icon} size="56" />} */}
            <p className="font-normal text-center font-primary uppercase text-[18px] text-[#000000] pb-2 md:text-[18px] mb-0 mt-s pt-3xs">
              {item.title}
            </p>
            <p className="text-center font-secondary mt-[2px] px-s md:px-0 font-secondary-light" style={{ fontSize: "12px" }}>
              {item.subtitle}
            </p>
          </div>
        </li>
      ))}
    </motion.ul>
  );
};

export default DataGrid;
